import React from 'react';

function FrontEnd() {
    return (
        <>
            <h1>Telas de testes para equipe de frontend</h1>
        </>
    );
}

export default FrontEnd;
